import { AdminDashboardUsersStaticsResponse } from '../../graphql/API';
import { adminGetDashboardUsersData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardUsersDataApi =
  async (): Promise<AdminDashboardUsersStaticsResponse> => {
    const result = await executeGql(adminGetDashboardUsersData, {});
    return processGqlResult<AdminDashboardUsersStaticsResponse>(
      'adminGetDashboardUsersData',
      result,
    );
  };
